import { Component } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
// @ts-ignore
import _ from "lodash";
import { AuthService } from "src/app/services/auth.service";
import { ProofreadingService } from "src/app/services/proofreading.service";
import { ExternStateName, InternStateName, IState } from "src/app/models/states.model";
import { FlowType, Proofreading } from "src/app/models/proofreading.model";
import { ProjectService } from "src/app/services/project.service";
import { StateMachineService } from "src/app/services/machine-state.service";
import { State } from "src/app/models/projects/project.model";


@Component({
    selector: "app-state-machine-intern",
    templateUrl: "./state-machine-intern.component.html",
    styleUrls: ["./state-machine-intern.component.scss"],
})
export class StateMachineInternComponent {

    get INTERN_STATE_NAME() {
        return InternStateName;
    }

    get proofreading(): Proofreading | undefined {
        return this.s_proofreadings.current;
    }

    get externState() {
        return this.proofreading?.state;
    }

    get internState() {
        return this.proofreading?.intern?.currentState;
    }

    get nextStates(): InternStateName[] | undefined {
        return this.internState?.next ? Object.keys(this.internState?.next) as InternStateName[] : undefined;
    }

    get nextStatesObject(): IState["next"] | undefined {
        return this.internState?.next || undefined;
    }

    get previousStates(): InternStateName[] | undefined {
        return this.internState?.previous ? Object.keys(this.internState?.previous) as InternStateName[] : undefined;

    }

    get computeUserAttributes() {
        return [
            ...(this.s_auth.user?.attributes_name || [])
        ];
    }

    get historyItem() {
        return {
            intern: this.s_proofreadings.currentHistory?.intern,
            extern: this.s_proofreadings.currentHistory?.extern,
            approval: this.s_proofreadings.currentHistory?.approval,
        };
    }

    get generating() {
        return this.internState?.slug === InternStateName.GENERATING;
    }

    constructor(
        protected dialog: MatDialog,
        protected s_auth: AuthService,
        public s_proofreadings: ProofreadingService,
        protected s_project: ProjectService,
        protected s_state_machine: StateMachineService
    ) {

    }

    async onNextState(nextState: InternStateName) {
        await this.s_proofreadings.onNextInternState(nextState);
    }

    async onPreviousState(previousState: InternStateName) {
        await this.s_proofreadings.onPreviousInternState(previousState);
    }

    previousCondition(previous: string): boolean | undefined {
        if (!this.internState) return false;
        return this.s_proofreadings.previousCondition(this.internState, previous, this.computeUserAttributes);
    }

    nextCondition(next: string): boolean | undefined {
        if (!this.internState) return false;
        return this.s_proofreadings.nextCondition(this.internState, next, this.computeUserAttributes);
    }

    disabledOnArchived(stateSlug: string): boolean {
        if (this.s_project.current?.state !== State.ARCHIVED) return false;
        const state = this.s_state_machine.entities.find(e => e.slug === stateSlug && e.type === 'intern' && e.flow.includes(this.proofreading!.flow));
        if (!state?.opts.includes("ALLOWED_ON_ARCHIVED")) return true;
        return false;
    }

    getTooltip(next: string, condition: Function): string {
        if (this.disabledOnArchived(next)) return 'NOT_ALLOWED_ON_ARCHIVED';
        return !condition.bind(this)(next) ? 'YOU_DONT_HAVE_THE_PRIVILEGE' : '';
    }

    getSlugText(next: string): string {
        const next_state = this.s_state_machine.entities.find(e => e.slug === next && e.type === 'intern' && e.flow.includes(this.proofreading!.flow));
        return next_state?.payload?.text_slug || next;
    }
}
